(function () {
// Configuration variables - get values from hidden fields
  let minWidth = parseInt(document.querySelector('[name="fabric_min_width"]')?.value) || 12;
  let maxWidth = parseInt(document.querySelector('[name="fabric_max_width"]')?.value) || 48;

  let widthValue = minWidth;

  let minLength = parseInt(document.querySelector('[name="fabric_min_length"]')?.value) || 12;
  let maxLength = parseInt(document.querySelector('[name="fabric_max_length"]')?.value) || 120;
  let lengthValue = minLength;

  let isInitializing = true;

// Generate array of numbers with increment
  const generateDataForSizesIncrement = (min, max, increment) => {
      const arrayOfOptions = [];
      for (let i = min; i <= max; i += increment) {
          arrayOfOptions.push(i);
      }
      return arrayOfOptions;
  };

// Generate array of numbers (1 by 1)
  const generateDataForSizes = (min, max) => {
      const arrayOfOptions = [];
      for (let i = min; i <= max; i++) {
          arrayOfOptions.push(i);
      }
      return arrayOfOptions;
  };

// Create select options in dropdown
  const createSelectOptions = (data, selectId) => {
      const selectElement = document.getElementById(selectId);
      if (!selectElement) return;

      selectElement.innerHTML = '';
      data.forEach((option, index) => {
          const optionElement = document.createElement('option');
          optionElement.value = option;
          optionElement.textContent = option;
          if (index === 0) {
              optionElement.selected = true;
          }
          selectElement.appendChild(optionElement);
      });
  };

  const subscribeToQuantityUpdates = () => {
      if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe !== 'undefined') {
          if (window.romanQuantityUpdateUnsubscribers) {
              window.romanQuantityUpdateUnsubscribers.forEach((unsub) => unsub?.());
          }
          window.romanQuantityUpdateUnsubscribers = [];

          const runSharedInventorySync = (data = {}) => {
              const productId = document.querySelector('input[name="product_id"]')?.value;
              if (!productId) return;

              const actualInventoryEl = document.getElementById("shared_inventory");
              const inventoryQuantityField = document.querySelector(`input[name="product_${productId}_inventory_quantity"]`);
              const inventoryProductId = document.querySelector(`input[name="product_${productId}_inventory_product_id"]`)?.value;
              if (!actualInventoryEl || !inventoryQuantityField || !inventoryProductId) return;

              const actualInventory = parseInt(actualInventoryEl.value, 10) || 0;
              let cartQuantity = 0;
              let sourceUsed = 'none';

              // Prefer the most authoritative source: full cart JSON from the
              // cart events. This is always consistent with the server state.
              if (data.cartData?.items) {
                  data.cartData.items.forEach((item) => {
                      if (String(item.properties?._inventory_product_id || '') === String(inventoryProductId)) {
                          const yardsPerUnit = Math.ceil(parseFloat(item.properties?._yards_per_unit || '1'));
                          cartQuantity += yardsPerUnit * (item.quantity || 0);
                      }
                  });
                  sourceUsed = 'cartData';
              } else {
                  // Next best: sum the currently rendered cart-drawer rows. They
                  // reflect the latest server state as the drawer is re-rendered
                  // after every change.
                  const cartInputs = document.querySelectorAll('input[name="updates[]"][data-inventory-product-id]');
                  if (cartInputs.length > 0) {
                      cartInputs.forEach((input) => {
                          if (String(input.dataset.inventoryProductId || '') !== String(inventoryProductId)) return;
                          const qty = parseInt(input.value, 10) || 0;
                          const yardsPerUnit = Math.ceil(parseFloat(input.dataset.yards || '1'));
                          cartQuantity += qty * yardsPerUnit;
                      });
                      sourceUsed = 'cartDom';
                  } else if (data.quantityForm) {
                      // Server-re-rendered quantity form (from product-info.js).
                      // Used only when no richer source is available.
                      const cartQuantityInput = data.quantityForm.querySelector('.quantity__input');
                      cartQuantity = cartQuantityInput ? parseInt(cartQuantityInput.getAttribute('data-cart-quantity'), 10) || 0 : 0;
                      sourceUsed = 'quantityForm';
                  } else {
                      const liveQtyInput = document.getElementById('product-configurator-quantity');
                      cartQuantity = liveQtyInput ? parseInt(liveQtyInput.getAttribute('data-cart-quantity'), 10) || 0 : 0;
                      sourceUsed = 'liveInput';
                  }
              }

              const remainingQuantity = Math.max(actualInventory - cartQuantity, 0);
              inventoryQuantityField.value = remainingQuantity;

              // After a successful add-to-cart from this product form, reset the
              // configurator quantity back to 1 so the next ATC click doesn't
              // re-add the previously selected quantity.
              if (data.source === 'product-form') {
                  const liveQtyInput = document.getElementById('product-configurator-quantity');
                  if (liveQtyInput) liveQtyInput.value = 1;
              }

              updateQuantityInput();
              calculatePrice();
          };

          // Cart updates for a single user action fire multiple events in quick
          // succession (cartUpdate, cartUpdateInMiniCart, quantity-update-rules),
          // sometimes with partial data. Debounce + merge so we only re-render
          // once using the richest payload, which avoids the configurator
          // flickering between intermediate states.
          let pendingData = null;
          let pendingTimer = null;
          const applySharedInventoryFromEvent = (data = {}) => {
              if (!pendingData) pendingData = {};
              if (data.cartData?.items) pendingData.cartData = data.cartData;
              if (data.quantityForm) pendingData.quantityForm = data.quantityForm;
              if (data.source) pendingData.source = data.source;

              if (pendingTimer) clearTimeout(pendingTimer);
              pendingTimer = setTimeout(() => {
                  const merged = pendingData || {};
                  pendingData = null;
                  pendingTimer = null;
                  runSharedInventorySync(merged);
              }, 60);
          };

          window.romanQuantityUpdateUnsubscribers.push(
              subscribe("quantity-update-rules", applySharedInventoryFromEvent)
          );
          window.romanQuantityUpdateUnsubscribers.push(
              subscribe(PUB_SUB_EVENTS.cartUpdate, applySharedInventoryFromEvent)
          );
          if (PUB_SUB_EVENTS.cartUpdateInMiniCart) {
              window.romanQuantityUpdateUnsubscribers.push(
                  subscribe(PUB_SUB_EVENTS.cartUpdateInMiniCart, applySharedInventoryFromEvent)
              );
          }

          // Initial sync on page load/re-entry (bypass debounce so the
          // configurator is ready immediately).
          runSharedInventorySync();
      } else {
          console.warn('⚠️ PUB_SUB_EVENTS or subscribe function not available');
      }
  };
  const createSubWidth = () => {
      const selectSubWidth = document.getElementById('select-sub-width-id');
// Generate 0/8 to 7/8
      for (let i = 0; i <= 7; i++) {
          let fraction = i === 0 ? '00' : i % 2 === 0 ? i / 2 + '/4' : i + '/8';
// Replace 2/4 with 1/2
          if (fraction === '2/4') {
              fraction = '1/2';
          }
          let decimalValue = i / 8;

          let option = document.createElement('option');
          option.value = fraction === '00' ? 0 : fraction;
          option.textContent = fraction;
          selectSubWidth.appendChild(option);
      }
  }

  const createSubLength = () => {
      const selectSubLength = document.getElementById('select-sub-length-id');

// Generate 0/8 to 7/8
      for (let i = 0; i <= 7; i++) {
          let fraction = i === 0 ? '00' : i % 2 === 0 ? i / 2 + '/4' : i + '/8';
// Replace 2/4 with 1/2
          if (fraction === '2/4') {
              fraction = '1/2';
          }
          let decimalValue = i / 8;

          let option = document.createElement('option');
          option.value = fraction === '00' ? 0 : fraction;
          option.textContent = fraction;
          option.setAttribute('data-sub-length-value', decimalValue); // decimal here

          selectSubLength.appendChild(option);
      }
  }
// Initialize dropdowns when DOM is ready
  const initializeDropdowns = () => {

// Generate options arrays
      const widthOptions = generateDataForSizesIncrement(minWidth, maxWidth, 1);
      const lengthOptions = generateDataForSizes(minLength, maxLength);

// Create dropdown options
      createSelectOptions(widthOptions, "product-configurator-width-select");
      createSelectOptions(lengthOptions, "product-configurator-height-select");

// Set initial values
      widthValue = widthOptions[0];
      lengthValue = lengthOptions[0];

      createSubWidth();
      createSubLength();

// Check initial state of sub-dimensions
      handleSubDimensionsState();

// Add event listeners
      setupEventListeners();

// Initialize yards display and quantity input
      updateYardsDisplay();
      updateQuantityInput();

  };

  const calculatePrice = (updatePriceItems = true) => {
//console.log("isInitializing", isInitializing);
      if (isInitializing) {
          return 0;
      }
// Get selected lining, design, mount, and lift data
      const selectedLining = window.selectedLining;
      const selectedDesign = window.selectedDesign;
      const selectedMount = window.selectedMount;
      const selectedLift = window.selectedLift;

      if (!selectedLining || !selectedDesign) {
//console.log('Missing lining or design selection');
          return 0;
      }

// Get pricing data from form inputs or data attributes
      const pricePerYardInput = document.querySelector('input[name="price_per_yard"]');
      const discountInput = document.querySelector('input[name="custom_product_discount"]');


// Convert Shopify prices from cents to dollars
      const liningBasePrice = (parseFloat(selectedLining.price) / 100) || 0;
      const designSelected = selectedDesign.title || '';
      const fabricationBasePrice = (parseFloat(selectedDesign.price) / 100) || 0;


// Get lift base price (from data attribute)
      const liftBasePrice = selectedLift ? parseFloat(selectedLift.price || 0) : 0;

//const widthForCalculation = getWidthForCalculation(widthValue);
      const widthForCalculation = 1
      const liningWeight = parseFloat(selectedLining.weight) || 0;
      const pricePerYard = pricePerYardInput ? parseFloat(pricePerYardInput.value) || 0 : 15; // Default fallback
      const cusDiscountVal = discountInput ? parseFloat(discountInput.value) || 0 : 0;

      const outputLength = getSubLengthDataValue();

      const totalYards = ((30 + parseFloat(lengthValue) + parseFloat(outputLength)) / 36) * parseInt(widthForCalculation);

// Get shipping price per pound from hidden field
      const shippingPricePerPoundInput = document.querySelector('input[name="shipping_price_per_pound"]');
//shippingPricePerPoundInput ? parseFloat(shippingPricePerPoundInput.value) || 11.5 :
    const pricePerPound = shippingPricePerPoundInput ? parseFloat(shippingPricePerPoundInput.value) || 11.85 : 11.85;


// Calculate individual costs (enhanced from live version)
      const fabricCost = (totalYards * pricePerYard);
      const liningCost = (totalYards * liningBasePrice);
      const fabricationCost = liftBasePrice;
      const weightPrice = window.selectedLining.weight;
      const totalWeight = weightPrice * totalYards + 2.5;
      const designCost = selectedDesign.price / 100;
      const shippingCost = totalWeight * pricePerPound;

      const additionalCost = parseFloat(fabricationCost) +
          parseFloat(designCost) +
          parseFloat(fabricCost) +
          parseFloat(liningCost) +
          parseFloat(shippingCost);

      const extraCharge = parseFloat(document.querySelector('input[name="product_extra_cost"]').value) || 0;

// Calculate total (enhanced calculation)
      const total = parseFloat(fabricCost) + parseFloat(liningCost) + parseFloat(fabricationCost) + parseFloat(shippingCost) + parseFloat(designCost) + parseFloat(additionalCost) + parseFloat(extraCharge);

// Apply discount
      const toFixedTotal = total.toFixed(2)
      const percentageValue = parseInt(cusDiscountVal) || 0;
      const discountValue = toFixedTotal / 100 * percentageValue;
      const discountedTotal = toFixedTotal - discountValue;


// Update price display elements
//updatePriceDisplay(total, discountedTotal);
      updateTotalPriceDisplay(total, discountedTotal, updatePriceItems);
      const productId = document.querySelector('input[name="product_id"]')?.value
      const totalCalculatedYards = Math.ceil(totalYards.toFixed(2));
      const inventoryQuantityField = document.querySelector(`input[name="product_${productId}_inventory_quantity"]`)?.value;
// Update debug price elements if they exist

      console.log('🎯 Price Calculation Details:', {
          pricePerYard,
          pricePerPound,
          discountPercentage: percentageValue,
          liningBasePrice,
          liftBasePrice,
          designSelected,
          weightPricePerWidth: liningWeight,
          widthForCalculation,
          totalYards: Math.ceil(totalYards.toFixed(2)),
          totalCalculatedYards,
          fabricCost: fabricCost.toFixed(2),
          liningCost: liningCost.toFixed(2),
          extraCharge: extraCharge,
          fabricationBasePrice: fabricationCost.toFixed(2),
          totalWithoutDiscount: total.toFixed(2),
          liningOption: selectedLining.title,
          totalWeight: totalWeight.toFixed(2),
          shippingCost: shippingCost.toFixed(2),
          discountValue: discountValue.toFixed(2),
          totalWithDiscount: discountedTotal.toFixed(2),
          totalAvailableQuantity: inventoryQuantityField

      });

      const quantityInput = document.getElementById('product-configurator-quantity');
      const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
      const totalWithQuantity = discountedTotal * quantity;
      const variantIdInput = document.querySelector('input[name="variant_id"]');
      const variantId = variantIdInput ? variantIdInput.value : null;
      const productData = getSelectedProductData();

// Update hidden fields with existence checks
      const attrTotalCalculatedPrice = document.getElementById('attr_total_calculated_price');
      if (attrTotalCalculatedPrice) attrTotalCalculatedPrice.value = totalWithQuantity.toFixed(2) || 0;

      const attrPricePerUnit = document.getElementById('attr_price_per_unit');
      if (attrPricePerUnit) attrPricePerUnit.value = discountedTotal.toFixed(2) || 0;

      const attrVariantId = document.getElementById('attr_variant_id');
      if (attrVariantId) attrVariantId.value = variantId;

      const attrYardsPerUnit = document.getElementById('attr_yards_per_unit');
      if (attrYardsPerUnit) attrYardsPerUnit.value = totalYards.toFixed(2) || 0;

      const attrInventoryProductId = document.getElementById('attr_inventory_product_id');
      if (attrInventoryProductId) attrInventoryProductId.value = productData?.inventory_product_id || 0;

      return discountedTotal;
  };

  const getSubLengthDataValue = () => {
      const selectSubLength = document.querySelector('#select-sub-length-id');
      return selectSubLength ? selectSubLength.options[selectSubLength.selectedIndex].getAttribute('data-sub-length-value') : 0;
  }
  /*const updatePriceDisplay = (regularPrice, discountedPrice) => {
  // Update regular price elements
  const regularPriceElements = document.querySelectorAll('.regular-price, .product-configurator-regular-price');
  regularPriceElements.forEach(el => {
  el.textContent = `$${regularPrice.toFixed(2)}`;
  });

  // Update discounted price elements
  const discountedPriceElements = document.querySelectorAll('.discounted-price, .product-configurator-price, .configurator-price');
  discountedPriceElements.forEach(el => {
  el.textContent = `$${discountedPrice.toFixed(2)}`;
  });

  // Update any total price elements
  const totalPriceElements = document.querySelectorAll('.total-price, .product-configurator-total-price');
  totalPriceElements.forEach(el => {
  el.textContent = `$${discountedPrice.toFixed(2)}`;
  });
  };*/

// Setup event listeners for dropdowns
  const setupEventListeners = () => {

      const widthSelect = document.getElementById("product-configurator-width-select");
      const heightSelect = document.getElementById("product-configurator-height-select");

      if (widthSelect) {
          widthSelect.addEventListener('change', function () {
              widthValue = this.value;
              handleSubDimensionsState(); // Check if sub-width should be disabled
              updateDisplay();
              updateYardsDisplay();
              updateQuantityInput();
              calculatePrice(); // Recalculate price when width changes
          });
      }

      if (heightSelect) {
          heightSelect.addEventListener('change', function () {
              lengthValue = this.value;
              handleSubDimensionsState(); // Check if sub-length should be disabled
              updateDisplay();
              updateYardsDisplay();
              updateQuantityInput();
              calculatePrice(); // Recalculate price when height changes
          });
      }

// Setup sub-length dropdown change listener
      const selectSubLength = document.getElementById('select-sub-length-id');
      if (selectSubLength) {
          selectSubLength.addEventListener('change', function () {
              updateDisplay();
              updateYardsDisplay();
              updateQuantityInput();
              calculatePrice(); // Recalculate price when sub-length changes
          });
      }

      const selectSubWidth = document.getElementById('select-sub-width-id');
      if (selectSubWidth) {
          selectSubWidth.addEventListener('change', function () {
              updateDisplay();
              updateYardsDisplay();
              updateQuantityInput();
              calculatePrice(); // Recalculate price when sub-length changes
          });
      }

// Setup lining product selection
      setupLiningSelection();

// Setup mount selection
      setupMountSelection();

// Setup lift selection
      setupLiftSelection();

// Setup design product selection
      setupDesignSelection();

// Setup price input change listeners
      setupPriceInputListeners();

// Setup quantity controls
      setupQuantityControls();

  };

// Setup listeners for price-related inputs
  const setupPriceInputListeners = () => {
      const pricePerYardInput = document.querySelector('input[name="price_per_yard"]');
      const discountInput = document.querySelector('input[name="custom_product_discount"]');

      if (pricePerYardInput) {
          pricePerYardInput.addEventListener('change', calculatePrice);
      }

      if (discountInput) {
          discountInput.addEventListener('change', calculatePrice);
      }
  };

  
// Update display elements
  const formatFraction = (value) => {
      if (value === null || value === undefined) return '0';
      const normalized = String(value).trim();
      return (normalized === '' || normalized === '00') ? '0' : normalized;
  };

  const formatDimensionValue = (whole, fraction) => {
      return `${whole}"${formatFraction(fraction)}`;
  };

  const updateDisplay = () => {
// Update any display elements that show current selection
      const dynamicWidthValues = document.querySelectorAll('.dynamic_width_value');
      const dynamicLengthValues = document.querySelectorAll('.dynamic_length_value');

      const subWidth = getSubWidth()
      const subLength = getSubLength()
      const formattedWidth = formatDimensionValue(widthValue, subWidth);
      const formattedLength = formatDimensionValue(lengthValue, subLength);

// Update all width elements
      dynamicWidthValues.forEach(element => {
          element.textContent = formattedWidth;
      });

// Update all length elements
      dynamicLengthValues.forEach(element => {
          element.textContent = formattedLength;
      });

      const attrWidth = document.getElementById('attr_width');
      if (attrWidth) attrWidth.value = formattedWidth;

      const attrHeight = document.getElementById('attr_height');
      if (attrHeight) attrHeight.value = formattedLength;

      const attrSize = document.getElementById('attr_size');
      if (attrSize) attrSize.value = `${formattedWidth}" W X ${formattedLength}" L`;
// Update yards calculation display
      updateYardsDisplay();
  };

// Setup mount selection
  const setupMountSelection = () => {

      const mountButtons = document.querySelectorAll('.select-mount-btn');
      mountButtons.forEach(button => {
          button.addEventListener('click', function () {
// Remove active class from all mount buttons
              mountButtons.forEach(btn => btn.classList.remove('selected'));

// Add active class to clicked button
              this.classList.add('selected');

              const mountType = this.getAttribute('data-mount-type');
              const title = this.getAttribute('data-title');
              const price = this.getAttribute('data-price');


// Store selected mount data
              window.selectedMount = {mountType, title, price};
              updateSelectionDisplay();

// Switch mount info display
              switchMountInfo();
          });

// Add hover functionality
          button.addEventListener('mouseenter', function () {
              const hoverTitle = this.getAttribute('data-title');
              const selectedMountTitle = document.querySelector('.selected-mount-title');
              const mountTitleElement = selectedMountTitle ? selectedMountTitle.querySelector('.selected-mount-title__title') : null;

              if (mountTitleElement) {
                  mountTitleElement.textContent = hoverTitle;
              }
          });

          button.addEventListener('mouseleave', function () {
              const selectedMountTitle = document.querySelector('.selected-mount-title');
              const mountTitleElement = selectedMountTitle ? selectedMountTitle.querySelector('.selected-mount-title__title') : null;

              if (mountTitleElement) {
                  const savedTitle = mountTitleElement.getAttribute('data-mount-title');
                  if (savedTitle) {
                      mountTitleElement.textContent = savedTitle;
                  }
              }
          });
      });
  };

// Switch mount info display based on selected mount
  const switchMountInfo = () => {
      const selectedMount = window.selectedMount;

      if (selectedMount && selectedMount.title === 'Inside') {
// Show depth info for inside mount
          const mainDepth = document.getElementById('main-depth');
          const insideMountInfo = document.getElementById('js-inside-mount-depth-info');

          if (mainDepth) mainDepth.style.display = 'block';
          if (insideMountInfo) insideMountInfo.style.display = 'block';

          updateAddToCartButton();

// Setup depth confirmation checkbox
          setupDepthConfirmation();
      } else {
// Hide depth info for outside mount
          const mainDepth = document.getElementById('main-depth');
          const insideMountInfo = document.getElementById('js-inside-mount-depth-info');

          if (mainDepth) mainDepth.style.display = 'none';
          if (insideMountInfo) insideMountInfo.style.display = 'none';

// Enable add to cart button for outside mount
          updateAddToCartButton();

      }
  };

// Setup depth confirmation checkbox functionality
  const setupDepthConfirmation = () => {
      const confirmDepthCheckbox = document.getElementById('confirm-depth');

      if (confirmDepthCheckbox) {
// Remove existing event listeners
          confirmDepthCheckbox.removeEventListener('change', handleDepthConfirmation);
          confirmDepthCheckbox.removeEventListener('click', handleDepthConfirmation);

// Add new event listeners
          confirmDepthCheckbox.addEventListener('change', handleDepthConfirmation);
          confirmDepthCheckbox.addEventListener('click', handleDepthConfirmation);
      }
  };

// Handle depth confirmation checkbox change
  const handleDepthConfirmation = () => {
      hideWindowDepthError(); // Clear inline error when user confirms depth
      updateAddToCartButton();
  };


// Setup lift selection
  const setupLiftSelection = () => {
      const liftRadioButtons = document.querySelectorAll('input[name="lift"]');

      liftRadioButtons.forEach(radio => {
          radio.addEventListener('change', function () {
              if (this.checked) {
                  const liftValue = this.value;
                  const liftTitle = this.getAttribute('data-lift-title');

// Get lift price from parent container
                  const liftContainer = document.querySelector('.select-lift-btn');
                  const liftPrice = liftContainer ? liftContainer.getAttribute('data-lift-price') : 0;


// Store selected lift data
                  window.selectedLift = {liftValue, liftTitle, price: liftPrice};
                  updateSelectionDisplay();
              }
          });
      });
  };

// Setup lining product selection
  const setupLiningSelection = () => {
      const liningButtons = document.querySelectorAll('.select-lining-btn');
      liningButtons.forEach(button => {
          button.addEventListener('click', function () {
// Remove active class from all lining buttons
              liningButtons.forEach(btn => btn.classList.remove('selected'));

// Add active class to clicked button
              this.classList.add('selected');

              const productId = this.getAttribute('data-product-id');
              const price = this.getAttribute('data-price');
              const title = this.getAttribute('data-title');
              const weight = this.getAttribute('data-weight');

// Get description from hidden HTML element
              const descriptionElement = document.getElementById(`product-description-${productId}`);
              const description = descriptionElement ? descriptionElement.innerHTML : '';

//console.log('Lining selected:', {productId, price, title, weight, description});

// Store selected lining data
              window.selectedLining = {productId, price, title, weight, description};
              updateSelectionDisplay();
//calculatePrice(); // Recalculate price when lining changes
          });

// Add hover functionality
          button.addEventListener('mouseenter', function () {
              const hoverTitle = this.getAttribute('data-title');
              const selectedLiningTitle = document.querySelector('.selected-lining-title');
              const liningTitleElement = selectedLiningTitle ? selectedLiningTitle.querySelector('.selected-lining-title__title') : null;

              if (liningTitleElement) {
                  liningTitleElement.textContent = hoverTitle;
              }
          });

          button.addEventListener('mouseleave', function () {
              const selectedLiningTitle = document.querySelector('.selected-lining-title');
              const liningTitleElement = selectedLiningTitle ? selectedLiningTitle.querySelector('.selected-lining-title__title') : null;

              if (liningTitleElement) {
                  const savedTitle = liningTitleElement.getAttribute('data-lining-title');
                  if (savedTitle) {
                      liningTitleElement.textContent = savedTitle;
                  }
              }
          });

      });
  };

// Setup design product selection
  const setupDesignSelection = () => {

      const designButtons = document.querySelectorAll('.product-options-card__select-design');
      designButtons.forEach(button => {
          button.addEventListener('click', function () {
// Remove active class from all design buttons
              designButtons.forEach(btn => btn.classList.remove('selected'));

// Add active class to clicked button
              this.classList.add('selected');

              const productId = this.getAttribute('data-product-id');
              const price = this.getAttribute('data-price');
              const title = this.getAttribute('data-title');

// Get description from hidden HTML element or fall back to data attribute
              const descriptionElement = document.getElementById(`product-description-${productId}`);
              const description = descriptionElement ? descriptionElement.innerHTML : '';

//console.log('Design selected:', {productId, price, title, description});


// Store selected design data
              window.selectedDesign = {productId, price, title, description};
              updateSelectionDisplay();
              updateYardsDisplay();
              updateQuantityInput();
//calculatePrice(); // Recalculate price when design changes
              changeSlide();
          });

// Add hover functionality
          button.addEventListener('mouseenter', function () {
              const hoverTitle = this.getAttribute('data-title');
              const selectedDesignTitle = document.querySelector('.selected-design-title');
              const designTitleElement = selectedDesignTitle ? selectedDesignTitle.querySelector('.selected-design-title__title') : null;

              if (designTitleElement) {
                  designTitleElement.textContent = hoverTitle;
              }
          });

          button.addEventListener('mouseleave', function () {
              const selectedDesignTitle = document.querySelector('.selected-design-title');
              const designTitleElement = selectedDesignTitle ? selectedDesignTitle.querySelector('.selected-design-title__title') : null;

              if (designTitleElement) {
                  const savedTitle = designTitleElement.getAttribute('data-design-title');
                  if (savedTitle) {
                      designTitleElement.textContent = savedTitle;
                  }
              }
          });
      });
  };

  const changeSlide = () => {
      const swiperEl = document.querySelector('.product-gallery-swiper');
      if (!swiperEl) {
          console.error('Swiper container not found');
          return;
      }

      const swiperInstance = swiperEl.swiper;
      if (!swiperInstance) {
          console.error('Swiper instance not available yet');
          return;
      }

      const slides = swiperInstance.slides;
      const targetIndex = Array.from(slides).findIndex(slide =>
          slide.getAttribute('data-swatch-media') === window.selectedDesign.title
      );

      if (targetIndex !== -1) {
          swiperInstance.slideTo(targetIndex);
      } else {
          console.warn('Slide with matching data-slide-id not found');
      }
  }

  const updateSelectionDisplay = () => {
      updateSizeDisplay();
      updateDesignSelectionDisplay();
      updateMountSelectionDisplay();
      updateLiftSelectionDisplay();
      updateLiningSelectionDisplay();
      calculatePrice();
      updateAddToCartButton();
      renderOrderSummary();
  };

  const updateSizeDisplay = () => {
// Update size display
      const dynamicWidthValues = document.querySelectorAll('.dynamic_width_value');
      const dynamicLengthValues = document.querySelectorAll('.dynamic_length_value');

      const subWidth = getSubWidth()
      const subLength = getSubLength()
      const formattedWidth = formatDimensionValue(widthValue, subWidth);
      const formattedLength = formatDimensionValue(lengthValue, subLength);

// Keep visible size text aligned with selected fractions
      dynamicWidthValues.forEach(element => {
          element.textContent = formattedWidth;
      });

      dynamicLengthValues.forEach(element => {
          element.textContent = formattedLength;
      });

      const attrWidth = document.getElementById('attr_width');
      if (attrWidth) attrWidth.value = formattedWidth;

      const attrHeight = document.getElementById('attr_height');
      if (attrHeight) attrHeight.value = formattedLength;

      const attrSize = document.getElementById('attr_size');
      if (attrSize) attrSize.value = `${formattedWidth}" W X ${formattedLength}" L`;

  }

  const updateDesignSelectionDisplay = () => {
// Update design selection display
      const designTitles = document.querySelectorAll('.selected-design-title__title');
      const designPrices = document.querySelectorAll('.selected-design-price');
      const designDescriptions = document.querySelectorAll('.selected-design-description');

      if (window.selectedDesign) {
// Update all design title elements (HTML content for all instances)
          designTitles.forEach(element => {
              element.innerHTML = `${window.selectedDesign.title}`;
          });

// Update data attribute only on the specific child element
          const selectedDesignTitle = document.querySelector('.selected-design-title');
          const designTitleElement = selectedDesignTitle ? selectedDesignTitle.querySelector('.selected-design-title__title') : null;
          if (designTitleElement) {
              designTitleElement.setAttribute('data-design-title', window.selectedDesign.title);
              const attrDesign = document.getElementById('attr_design');
              if (attrDesign) attrDesign.value = window.selectedDesign.title;
          }

// Update all design price elements
          designPrices.forEach(element => {
              element.innerHTML = `$${(window.selectedDesign.price / 100).toFixed(2)}`;
          });

// Update all design description elements
          designDescriptions.forEach(element => {
              element.innerHTML = window.selectedDesign.description || '';
          });
      } else {
// Clear all design elements when no design is selected
          designTitles.forEach(element => {
              element.textContent = '';
          });
          designDescriptions.forEach(element => {
              element.textContent = '';
          });
      }
  }

  const updateMountSelectionDisplay = () => {
      const mountTitles = document.querySelectorAll('.selected-mount-title__title');

      if (window.selectedMount) {
// Update all mount title elements
          mountTitles.forEach(element => {
              element.innerHTML = `${window.selectedMount.title}`;
          });

// Update data attribute only on the specific child element
          const selectedMountTitle = document.querySelector('.selected-mount-title');
          const mountTitleElement = selectedMountTitle ? selectedMountTitle.querySelector('.selected-mount-title__title') : null;
          if (mountTitleElement) {
              mountTitleElement.setAttribute('data-mount-title', window.selectedMount.title);
              const attrMount = document.getElementById('attr_mount');
              if (attrMount) attrMount.value = window.selectedMount.title;
          }
      } else {
// Clear all mount elements when no mount is selected
          mountTitles.forEach(element => {
              element.textContent = '';
          });
      }
  }

  const updateLiftSelectionDisplay = () => {
      const liftTitles = document.querySelectorAll('.selected-lift-title__title');

      if (window.selectedLift) {
// Update all lift title elements
          liftTitles.forEach(element => {
              element.innerHTML = `${window.selectedLift.liftTitle}`;
          });

// Update data attribute only on the specific child element
          const selectedLiftTitle = document.querySelector('.selected-lift-title');
          const liftTitleElement = selectedLiftTitle ? selectedLiftTitle.querySelector('.selected-lift-title__title') : null;
          if (liftTitleElement) {
              liftTitleElement.setAttribute('data-lift-title', window.selectedLift.liftTitle);
              const attrLift = document.getElementById('attr_lift');
              if (attrLift) attrLift.value = window.selectedLift.liftTitle;
          }
      } else {
// Clear all lift elements when no lift is selected
          liftTitles.forEach(element => {
              element.textContent = '';
          });
      }
  }

  const updateLiningSelectionDisplay = () => {
      const liningTitles = document.querySelectorAll('.selected-lining-title__title');
      const liningDescriptions = document.querySelectorAll('.selected-lining-description');

      const selectedLiningTitle = document.querySelector('.selected-lining-title');
      const liningTitleElement = selectedLiningTitle ? selectedLiningTitle.querySelector('.selected-lining-title__title') : null;


      if (window.selectedLining) {
          if (liningTitleElement) {
              liningTitleElement.setAttribute('data-lining-title', window.selectedLining.title);
              const attrLining = document.getElementById('attr_lining');
              if (attrLining) attrLining.value = window.selectedLining.title;
          }

// Update all lining title elements
          liningTitles.forEach(element => {
              element.innerHTML = `${window.selectedLining.title}`;
          });

// Update all lining description elements
          liningDescriptions.forEach(element => {
              element.innerHTML = window.selectedLining.description || '';
          });
      } else {
// Clear all lining elements when no lining is selected
          liningTitles.forEach(element => {
              element.textContent = 'Please select a lining product';
          });
          liningDescriptions.forEach(element => {
              element.textContent = 'No lining selected';
          });
      }
      if (!isInitializing) {
          calculatePrice();
      }
  }

// Update total price display and add to cart button state
  const updateTotalPriceDisplay = (total = null, singlePrice = null, updatePriceItems = true) => {
// If no single price provided, calculate it (only when called independently)
      if (singlePrice === null && !isInitializing) {
          singlePrice = calculatePrice(updatePriceItems);
      } else if (singlePrice === null) {
          singlePrice = 0; // Default to 0 during initialization
      }

      const quantityInput = document.getElementById('product-configurator-quantity');
      const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

      const totalPrice = (singlePrice.toFixed(2)) * quantity;

// ALWAYS update the total display
      const totalDisplayElement = document.querySelector('.product-configurator-total-display');
      if (totalDisplayElement) {
          totalDisplayElement.textContent = `$${totalPrice.toFixed(2)}`;
      }

// Update cutoff price (original price before discount) scaled by quantity
      const cutoffDisplayElement = document.querySelector('.product-configurator-total-cutoff');
      const discountPercentageElement = document.querySelector('.product-configurator-total-discount-percentage');

      if (cutoffDisplayElement && total !== null) {
          const totalCutoffPrice = total * quantity;
          cutoffDisplayElement.textContent = `$${totalCutoffPrice.toFixed(2)}`;

// Show/hide cutoff price based on whether there's a discount
          const cutoffWrapper = cutoffDisplayElement.closest('.product-form__total-price-cutoff');
          if (cutoffWrapper) {
              if (total > singlePrice) {
                  cutoffWrapper.style.display = '';
              } else {
                  cutoffWrapper.style.display = 'none';
              }
          }
      }

// Update discount percentage display
      if (discountPercentageElement && total !== null) {
          const discountWrapper = discountPercentageElement.closest('.product-form__total-price-discount');
          if (discountWrapper) {
              if (total > singlePrice) {
                  const discountPercentage = Math.round(((total - singlePrice) / total) * 100);
                  discountPercentageElement.textContent = `${discountPercentage}% off`;
                  discountWrapper.style.display = '';
              } else {
                  discountWrapper.style.display = 'none';
              }
          }
      }

// ONLY update price items when configuration changes (not on quantity change)
      if (updatePriceItems) {
          const sectionEl = document.querySelector('input[name="section_id"]');

          if (sectionEl) {

              const sectionId = sectionEl.value;

              const priceSectionEl = document.querySelectorAll(`#price-${sectionId}`);

              if (priceSectionEl) {

                  priceSectionEl.forEach(priceSection => {

//if there is not on sale
                      const regularPrice = priceSection.querySelector('.price__regular');
                      if (regularPrice) {
                          const priceItemRegular = regularPrice.querySelector('.price-item--regular');
                          if (priceItemRegular) {
                              priceItemRegular.textContent = `$${parseFloat(singlePrice).toFixed(2)}`;
                          }
                      }

//if there is a sale
                      const salePrice = priceSection.querySelector('.price__sale');
                      if (salePrice) {
                          const priceItemLast = salePrice.querySelector('.price-item--last');
                          if (priceItemLast) {
                              priceItemLast.textContent = `$${parseFloat(singlePrice).toFixed(2)}`;
                          }

                          const tradeCustomer = document.querySelector('input[name="trade_customer"]')?.value;
                          if (tradeCustomer) {
                              if (total && total > singlePrice) {
                                  const discountPercentage = Math.round(((total - singlePrice) / total) * 100);
                                  const salePercentageEl = priceSection.querySelector('.sale-percentage');
                                  if (salePercentageEl) {
                                      salePercentageEl.textContent = `${discountPercentage}% off`;
                                  }
                              }
                          }

                          if (total) {
                              const priceItemRegular = salePrice.querySelector('.price-item--regular');
                              if (priceItemRegular) {
                                  priceItemRegular.textContent = `$${total.toFixed(2)}`;
                              }
                          }
                      }
                  });
              }
          }
      }
  };

// Render order summary (from live version) - Updated for your HTML structure
  const renderOrderSummary = () => {
      const selectedDesign = window.selectedDesign ? window.selectedDesign.title : 'Not Selected';
      const selectedMount = window.selectedMount ? window.selectedMount.title : 'Not Selected';
      const selectedLining = window.selectedLining ? window.selectedLining.title : 'Not Selected';
      const selectedLift = window.selectedLift ? window.selectedLift.liftTitle : 'Not Selected';

// Update selection summary elements (your actual HTML classes)
      const selectionSummaryElements = {
          '.selected-design-title__title': selectedDesign,
          '.selected-mount-title__title': selectedMount,
          '.selected-lining-title__title': selectedLining,
          '.selected-lift-title__title': selectedLift
      };

      Object.entries(selectionSummaryElements).forEach(([selector, value]) => {
          const elements = document.querySelectorAll(selector);
          elements.forEach(el => {
              el.textContent = value;
          });
      });

// Update size display in selection summary
      const widthElements = document.querySelectorAll('.selection-summary .dynamic_width_value');
      const lengthElements = document.querySelectorAll('.selection-summary .dynamic_length_value');
      const subWidth = getSubWidth();
      const subLength = getSubLength();
      const formattedWidth = formatDimensionValue(widthValue, subWidth);
      const formattedLength = formatDimensionValue(lengthValue, subLength);

      widthElements.forEach(el => el.textContent = formattedWidth);
      lengthElements.forEach(el => el.textContent = formattedLength);

// Update quantity summary
      const quantitySummary = document.querySelector('.selection-summary .quantity-summary');
      if (quantitySummary) {
          const quantity = document.getElementById('product-configurator-quantity')?.value || 1;
          quantitySummary.textContent = `${quantity} Shade${quantity > 1 ? 's' : ''}`;
      }
  };

// Update add to cart button state
  const updateAddToCartButton = () => {
      const productId = document.querySelector('input[name="product_id"]')?.value;
      if (!productId) return;

      const addToCartButton = document.querySelector(`.product-form__submit-${productId}`);
      if (!addToCartButton) return;

      const hasLining = window.selectedLining;
      const hasDesign = window.selectedDesign;
      

      const quantityInput = document.getElementById("product-configurator-quantity");
      if (quantityInput) {
          const maxQuantity = quantityInput.max;
          if (maxQuantity < 1) {
              quantityInput.value = 0;
              disableATC();
              return;
          }
      } else {
          enableATC();
      }

      if (addToCartButton) {
          const textSpan = addToCartButton.querySelector('.text-span');

// Always show "Add to Cart" and keep button enabled when lining + design selected
// (Window depth is validated on submit via inline error, not by disabling the button)
          if (hasLining && hasDesign) {
// Don't enable button until page has fully loaded
              if (document.readyState !== 'complete') {
                  if (textSpan) textSpan.textContent = 'Add to Cart';
                  window.addEventListener('load', function () {
                      updateAddToCartButton();
                  }, {once: true});
                  return;
              }
              addToCartButton.disabled = false;
              addToCartButton.style.opacity = '1';
              addToCartButton.style.cursor = 'pointer';
              if (textSpan) textSpan.textContent = 'Add to Cart';
          } else {
              if (textSpan) textSpan.textContent = 'Select Products First';
              addToCartButton.disabled = true;
              addToCartButton.style.opacity = '0.5';
              addToCartButton.style.cursor = 'not-allowed';
          }
      }
  };

// Window depth inline error (no alert, no disabling ATC)
  const WINDOW_DEPTH_ERROR_SELECTOR = '.window-depth__field--error';

  const showWindowDepthError = () => {
      const errorEl = document.querySelector(WINDOW_DEPTH_ERROR_SELECTOR);
      if (!errorEl) return;
      errorEl.classList.remove('hide');
      errorEl.classList.add('is-visible');
      errorEl.scrollIntoView({behavior: 'smooth', block: 'center'});
  };

  const hideWindowDepthError = () => {
      const errorEl = document.querySelector(WINDOW_DEPTH_ERROR_SELECTOR);
      if (!errorEl) return;
      errorEl.classList.add('hide');
      errorEl.classList.remove('is-visible');
  };

  const setupWindowDepthFormValidation = () => {
      const form = document.querySelector('.product-form.primary-atc');
      if (!form || form.dataset.romanDepthValidationAttached === 'true') return;

      form.dataset.romanDepthValidationAttached = 'true';
      form.addEventListener('submit', (e) => {
          const mainDepth = document.getElementById('main-depth');
          const isDepthSectionVisible = mainDepth && mainDepth.style.display !== 'none';
          const confirmDepthCheckbox = document.getElementById('confirm-depth');
          const depthConfirmed = confirmDepthCheckbox ? confirmDepthCheckbox.checked : false;

          if (isDepthSectionVisible && !depthConfirmed) {
              e.preventDefault();
              e.stopImmediatePropagation();
              showWindowDepthError();
              return;
          }
          hideWindowDepthError();
      }, true);
  };

  const getSubLength = () => {
      return document.querySelector('#select-sub-length-id').value;
  }
  const getSubWidth = () => {
      return document.querySelector('#select-sub-width-id').value;
  }
  const calculateYards = () => {

//const widthForCalculation = getWidthForCalculation(widthValue);
      const widthForCalculation = 1

      const outputLength = getSubLengthDataValue();

      const totalYards = ((30 + parseFloat(lengthValue) + parseFloat(outputLength)) / 36) * parseInt(widthForCalculation);

      return {
          totalYards: totalYards,
          widthForCalculation: widthForCalculation
      };
  };

// Update yards calculation display
  const updateYardsDisplay = () => {

      const yardsCalculation = calculateYards();
      const displayElement = document.querySelector('.yards-calculation-display');

      if (displayElement) {
// Get sub-length value for display
          const outputLength = getSubLength();
// Add space only if value is zero
          const outputLengthDisplay = (outputLength === '0' || outputLength === 0 || outputLength === '00') ? ' ' + outputLength : outputLength;

          displayElement.textContent = `${widthValue}" W × ${lengthValue}" ${outputLengthDisplay} H = ${yardsCalculation.totalYards.toFixed(2)} yards (${yardsCalculation.widthForCalculation} panels)`;
      }

// Update hidden input
      const calculatedYardsInput = document.getElementById('calculated-yards');
      if (calculatedYardsInput) {
          calculatedYardsInput.value = yardsCalculation.totalYards.toFixed(2);
      }
  };

// Handle sub-width and sub-length enable/disable based on max values
  const handleSubDimensionsState = () => {
      const selectSubWidth = document.getElementById('select-sub-width-id');
      const selectSubLength = document.getElementById('select-sub-length-id');

// Handle sub-width based on width value
      if (selectSubWidth) {
          if (parseInt(widthValue) === maxWidth) {
// Disable and reset sub-width when at maximum
              selectSubWidth.value = '0';
              selectSubWidth.disabled = true;
              selectSubWidth.style.opacity = '0.5';
              selectSubWidth.style.cursor = 'not-allowed';
          } else {
// Enable sub-width when not at maximum
              selectSubWidth.disabled = false;
              selectSubWidth.style.opacity = '1';
              selectSubWidth.style.cursor = 'pointer';
          }
      }

// Handle sub-length based on length value
      if (selectSubLength) {
          if (parseInt(lengthValue) === maxLength) {
// Disable and reset sub-length when at maximum
              selectSubLength.value = '0';
              selectSubLength.disabled = true;
              selectSubLength.style.opacity = '0.5';
              selectSubLength.style.cursor = 'not-allowed';
          } else {
// Enable sub-length when not at maximum
              selectSubLength.disabled = false;
              selectSubLength.style.opacity = '1';
              selectSubLength.style.cursor = 'pointer';
          }
      }
  };

// Helper function to get variant ID from hidden field
  const getVariantId = () => {
      const variantIdInput = document.querySelector('input[name="variant_id"]');
      return variantIdInput ? variantIdInput.value : null;
  };

// Helper function to get product data from hidden fields
  const getProductDataFromHiddenFields = () => {
// Get the product ID from the current page URL or a hidden field
      const productId = document.querySelector('input[name="product_id"]')?.value

      const inventoryQuantityField = document.querySelector(`input[name="product_${productId}_inventory_quantity"]`);
      const inventoryPolicyField = document.querySelector(`input[name="product_${productId}_inventory_policy"]`);
      const inventoryManagementField = document.querySelector(`input[name="product_${productId}_inventory_management"]`);
      const priceField = document.querySelector(`input[name="product_${productId}_price"]`);
      const availableField = document.querySelector(`input[name="product_${productId}_available"]`);
      const titleField = document.querySelector(`input[name="product_${productId}_title"]`);
      const inventoryProductIdField = document.querySelector(`input[name="product_${productId}_inventory_product_id"]`);

      if (!inventoryQuantityField) {
          disableATC();
          const quantitySelector = document.querySelector(`.quantity-selector-${productId}`);
          if (quantitySelector) {
              quantitySelector.style.display = "none";
          }
      }
      if (!inventoryQuantityField || !priceField || !availableField) {
          console.warn(`Product data not found for product ID: ${productId}`);
      }

      return {
          id: productId,
          title: titleField ? titleField.value : '',
          price: parseInt(priceField?.value) || 0,
          inventory_quantity: parseInt(inventoryQuantityField?.value) || 0,
          inventory_policy: inventoryPolicyField ? inventoryPolicyField.value : 'deny',
          inventory_management: inventoryManagementField ? inventoryManagementField.value : null,
          available: availableField ? availableField.value === 'true' : false,
          inventory_product_id: inventoryProductIdField ? inventoryProductIdField.value : ''
      };
  };

// Get selected product data
  const getSelectedProductData = () => {
// Use the globally stored Shopify product data
      if (window.selectedShopifyProduct) {
          return {
              productId: window.selectedShopifyProduct.id,
              inventoryQuantity: window.selectedShopifyProduct.inventory_quantity,
              inventoryPolicy: window.selectedShopifyProduct.inventory_policy,
              inventoryManagement: window.selectedShopifyProduct.inventory_management,
              price: window.selectedShopifyProduct.price,
              available: window.selectedShopifyProduct.available,
              inventory_product_id: window.selectedShopifyProduct.inventory_product_id
          };
      }

// Get product details from hidden fields
      const productData = getProductDataFromHiddenFields();

      if (productData) {
          return {
              productId: productData.id,
              inventoryQuantity: productData.inventory_quantity,
              inventoryPolicy: productData.inventory_policy,
              inventoryManagement: productData.inventory_management,
              price: productData.price,
              available: productData.available,
              inventory_product_id: productData?.inventory_product_id
          };
      }

      return null;
  };

// Populate quantity dropdown based on selected variant inventory
  const disableATC = () => {
      const productId = document.querySelector('input[name="product_id"]')?.value;
      if (!productId) return;

      const ATC_buton = document.querySelector(`.product-form__submit-${productId}`);
      if (!ATC_buton) return;

      const textSpan = ATC_buton.querySelector('.text-span');
      if (textSpan) textSpan.textContent = "Sold out";

      ATC_buton.style.opacity = "0.5";
      ATC_buton.style.cursor = "not-allowed";
      ATC_buton.disabled = true;
  }
  const enableATC = () => {
      const productId = document.querySelector('input[name="product_id"]')?.value;
      if (!productId) return;

      const addToCartButton = document.querySelector(`.product-form__submit-${productId}`);
      if (!addToCartButton) return;

// Don't enable the button until the page has fully loaded
      if (document.readyState !== 'complete') {
          window.addEventListener('load', function () {
              enableATC();
          }, {once: true});
          return;
      }

      addToCartButton.disabled = false;
      addToCartButton.style.opacity = '1';
      addToCartButton.style.cursor = 'pointer';

      const textSpan = addToCartButton.querySelector('.text-span');
      if (textSpan) textSpan.textContent = 'Add to Cart';
  }

  const disableQuantityInputField = () => {
      const quantityInput = document.getElementById('product-configurator-quantity');
      quantityInput.disabled = true;
      quantityInput.value = 0;
      quantityInput.max = 0;
      quantityInput.setAttribute('data-max', 0);
      disableATC()
  }

  const updateQuantityInput = () => {
      const quantityInput = document.getElementById('product-configurator-quantity');

      if (!quantityInput) {
          console.warn('❌ quantityInput element not found!');
          return;
      }

      const plusButton = quantityInput.parentElement.querySelector('button[name="plus"]');
      const minusButton = quantityInput.parentElement.querySelector('button[name="minus"]');
      const productData = getSelectedProductData();

      if (!productData) {
          console.warn('❌ productData not found!');
          return;
      }

      const yardsPerUnit = Math.ceil(calculateYards().totalYards);
      const {inventoryQuantity, inventoryPolicy, available} = productData;

// Handle unavailable product
      if (!available || (inventoryPolicy === 'deny' && inventoryQuantity <= 0)) {
          disableQuantityInputField();
          minusButton.classList.add('disabled');
          plusButton.classList.add('disabled');
          return;
      }

// Compute maximum quantity in units
      const maxQuantity = yardsPerUnit > 0
          ? Math.floor(inventoryQuantity / yardsPerUnit)
          : inventoryQuantity;

      const actualMaxQuantity = maxQuantity;

      const hasEnoughInventory = inventoryQuantity >= yardsPerUnit;

// Common input setup
      quantityInput.disabled = false;
      quantityInput.min = 1;
      quantityInput.max = actualMaxQuantity;
      quantityInput.setAttribute('data-max', actualMaxQuantity);

// ATC + buttons state
      if (actualMaxQuantity < 1 || !hasEnoughInventory) {
          quantityInput.value = 0;
          quantityInput.disabled = true;
          disableATC();
          plusButton.classList.add('disabled');
          updateQuantitySummary(quantityInput);
      } else {
          quantityInput.value = Math.min(
              Math.max(parseInt(quantityInput.value) || 1, 1),
              actualMaxQuantity
          );
//enableATC();
          updateAddToCartButton()

          const currentValue = parseInt(quantityInput.value) || 1;
// Disable minus if at 1, disable plus if at max
          minusButton.classList.toggle('disabled', currentValue <= 1);
          plusButton.classList.toggle('disabled', currentValue >= actualMaxQuantity);
          updateQuantitySummary(quantityInput);
      }
  };


  const setupQuantityControls = () => {
      const quantityInput = document.getElementById('product-configurator-quantity');


      if (quantityInput) {
// Listen for both input and change events
          quantityInput.addEventListener('input', function () {
              updateTotalPriceDisplay(null, null, false); // Don't update price items on quantity change
              updateAddToCartButton();
              updateQuantitySummary(quantityInput);
          });

          quantityInput.addEventListener('change', function () {
              updateTotalPriceDisplay(null, null, false); // Don't update price items on quantity change
              updateAddToCartButton();
              updateQuantitySummary(quantityInput);
          });

// Validate input to ensure it doesn't exceed max
          quantityInput.addEventListener('blur', function () {
              const max = parseInt(quantityInput.max);
              const min = parseInt(quantityInput.min);
              const current = parseInt(quantityInput.value);

              if (current > max) {
                  quantityInput.value = max;
                  updateTotalPriceDisplay(null, null, false); // Don't update price items on quantity change
                  updateAddToCartButton();
                  updateQuantitySummary(quantityInput);
              } else if (current < min) {
                  quantityInput.value = min;
                  updateTotalPriceDisplay(null, null, false); // Don't update price items on quantity change
                  updateAddToCartButton();
                  updateQuantitySummary(quantityInput);
              }
          });
      }
  };

  const updateQuantitySummary = (quantityInput) => {
      if (!quantityInput) return;

      const quantitySummary = document.querySelector('.quantity-summary');
      if (quantitySummary) {
          quantitySummary.textContent = `${quantityInput.value} Shade${quantityInput.value > 1 ? 's' : ''}`;
      }

      const primaryATC = document.querySelector('.primary-atc');
      if (primaryATC) {
          const quantityField = primaryATC.querySelector('#quantity');
          if (quantityField) {
              quantityField.value = quantityInput.value;
          }
      }
  };
  const updateColorSelection = () => {


      const colorVariantsFull = document.querySelector('.color-variants-full');
//console.log("colorVariantsFull", colorVariantsFull);
      if (colorVariantsFull) {
          const activeColor = colorVariantsFull.querySelector('.is-active');
//console.log("activeColor", activeColor);
          if (activeColor) {
              const colorValue = activeColor.dataset.color;
//console.log("color value", colorValue);
              if (colorValue) {

                  const selectedColorTitle = document.querySelector('.selected-color-title');
                  if (selectedColorTitle) {
                      selectedColorTitle.innerHTML = colorValue;
                  }
              }
          }
      }
  };

// Set default selections for lining and header
  const setDefaultSelections = () => {
      console.log('Setting default selections...');

// Select first available lining option
      const liningButtons = document.querySelectorAll('.select-lining-btn');
      if (liningButtons.length > 0) {
//console.log('Auto-selecting first lining option');
          liningButtons[0].click();
      }

// Select first available design option
      const designButtons = document.querySelectorAll('.product-options-card__select-design');
      if (designButtons.length > 0) {
//console.log('Auto-selecting first design option');
          designButtons[0].click();
      }

// Select first available mount option
      const mountButtons = document.querySelectorAll('.select-mount-btn');
      if (mountButtons.length > 0) {
//console.log('Auto-selecting first mount option');
          mountButtons[0].click();
      }

// Select first available lift option (LEFT is checked by default)
      const leftLiftRadio = document.querySelector('input[name="lift"][value="left"]');
      if (leftLiftRadio) {
//console.log('Auto-selecting LEFT lift option');
          leftLiftRadio.checked = true;
// Trigger change event to update display
          const event = new Event('change', {bubbles: true});
          leftLiftRadio.dispatchEvent(event);
      }

// Update displays after default selections
      setTimeout(() => {
          updateSelectionDisplay();
          updateYardsDisplay();
          updateQuantityInput();
          updateAddToCartButton();
          updateColorSelection();
          switchMountInfo();

          isInitializing = false;
          calculatePrice();
      }, 100);
  };
// Get current configuration
  const getCurrentConfiguration = () => {
      return {
          width: widthValue,
          height: lengthValue,
          selectedLining: window.selectedLining,
          selectedDesign: window.selectedDesign,
          selectedProduct: getSelectedProductData(),
          variantId: getVariantId(),
          pricePerYard: document.querySelector('input[name="price_per_yard"]')?.value,
          quantity: parseInt(document.getElementById('product-configurator-quantity')?.value) || 1
      };
  };

// Common initialization function
  const initialize = () => {

      initializeDropdowns();
      subscribeToQuantityUpdates();
      updateAddToCartButton(); // Initialize button state
      setupWindowDepthFormValidation(); // Validate window depth on submit (inline error, no disable)
// Set default selections after a short delay to ensure DOM is fully ready
      setTimeout(() => {
          setDefaultSelections();
      }, 200);

  };

  initialize();

// Expose functions globally if needed
  window.productConfigurator = {
      getCurrentConfiguration,
      updateDisplay,
      calculatePrice,
      updateTotalPriceDisplay,
      updateAddToCartButton,
      widthValue: () => widthValue,
      lengthValue: () => lengthValue
  };
  document.addEventListener('DOMContentLoaded', function () {
      document.querySelector('.measurement-detail-close')?.addEventListener('click', function (e) {
          e.preventDefault();
          document.querySelector('.measurement-detail')?.classList.add('measurement-detail-modal');
          document.querySelector('.size-option-wrapper')?.classList.remove('size-option-wrapper-hide');
      });
  });
  const triggerBtn = document.querySelector('.form__label-help--size-modal');
  const targetEl = document.querySelector('.measurement-popup-modal__button');

  if (triggerBtn && targetEl) {
      triggerBtn.addEventListener('click', function (e) {
          e.preventDefault();
          targetEl.click(); // simulate click
// OR if you want to toggle a modal manually:
// targetEl.classList.add('active');
      });
  }

})();

